export default "__VITE_ASSET__DRI0aPU1__"